export const useNotification = () => {
  type NotificationState = 'shown' | 'dismissed' | 'unset'
  const notification = ref<NotificationState>('unset')

  const notificationShown = computed(() => notification.value === 'shown')
  const notificationDismissed = computed(() => notification.value === 'dismissed')
  const notificationUnset = computed(() => notification.value === 'unset')

  const showNotification = () => notification.value = 'shown'
  const dismissNotification = () => notification.value = 'dismissed'
  const removeNotification = () => notification.value = 'unset'

  return {
    notificationShown,
    notificationDismissed,
    notificationUnset,
    showNotification,
    dismissNotification,
    removeNotification,
  }
}
